__webpack_require__.p = "/reports-candidates-work-location/referrals-hub/";